import { getObjectUtil } from 'packages/src'
import {
  STRIPE_KEY,
  STRIPE_PATH
} from 'modules/stripe/redux/constants/index.js'

export const isFormCompleteStripeSelect = (state) => {
  return !!getObjectUtil(state, STRIPE_PATH[STRIPE_KEY.IS_FORM_COMPLETE])
}
